import { store } from '@redux/store';
import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import uiStateSlice from 'layout/redux/uiStateSlice';
import { filter, fromEvent, map } from 'rxjs';

const siteLinks = 'Site Links';
const navigation = 'Navigation';
const navLinks = document.querySelector('[data-nav-links]');
const eventsMapper = new Map();

// Advertise
eventsMapper.set('header_advertise', new GoogleAnalyticsEvent('Outbound Links', navigation, 'Builder Advertising'));
// Resources
eventsMapper.set('header_reviews', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Trustbuilder Ratings & Reviews clicks'));
eventsMapper.set('header_learn', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Homebuying Learning Center clicks'));
eventsMapper.set('header_first_time_homebuyers', new GoogleAnalyticsEvent(siteLinks, navigation,
    'First Time Home Buyers clicks'));
eventsMapper.set('header_custom_homes_center', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Custom Home Buyers clicks'));
eventsMapper.set('header_55_plus', new GoogleAnalyticsEvent(siteLinks, navigation,
    '55+ Home Buyers clicks'));
eventsMapper.set('header_military_buyers', new GoogleAnalyticsEvent(siteLinks, navigation,
    'For the Military clicks'));
eventsMapper.set('header_homebuying_tools', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Home Buying Tools clicks'));
eventsMapper.set('header_affordability_calculator', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Affordability Calculator clicks'));
eventsMapper.set('header_home_buying_tools', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Homeownership Cost Calculator clicks'));
eventsMapper.set('header_credit_score', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Credit Score clicks'));
eventsMapper.set('header_mortgage_calculator', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Mortgage Calculator clicks'));
eventsMapper.set('header_get_preapproved', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Get Pre-Approved clicks'));
eventsMapper.set('header_prep_home_for_sale', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Prep Home for Sale clicks'));
eventsMapper.set('header_homeowners_insurance', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Homeowners Insurance'));
eventsMapper.set('header_get_offers', new GoogleAnalyticsEvent(siteLinks, navigation,
    'Get Offers clicks'));
eventsMapper.set('header_home_buying_tools_landing', new GoogleAnalyticsEvent(siteLinks, navigation,
    'See All Homebuying Tools'));

const metroLinksContainer = document.querySelector('[data-metro-links]');

function trackGAMetroLinkEvent(element) {
    const linkvalue = element.text;
    const googleAnalyticsDTO = new GoogleAnalyticsEvent(siteLinks, 'Header Metro Link', `${linkvalue} Clicks`) 
        
    store.dispatch(uiStateSlice.actions.trackUserEvent({googleAnalyticsDTO}))
}

fromEvent(metroLinksContainer, 'click')
    .pipe(
        map((element)=> element.target.closest('a')),
        filter(Boolean)
    )
    .subscribe(trackGAMetroLinkEvent);

const stateLinksContainer = document.querySelector('[data-state-links]');

function trackGAStateLinkEvent(element) {
    const linkvalue = element.text;
    const googleAnalyticsDTO = new GoogleAnalyticsEvent(siteLinks, 'Header State Link', `${linkvalue} Clicks`) 
        
    store.dispatch(uiStateSlice.actions.trackUserEvent({googleAnalyticsDTO}))
}

fromEvent(stateLinksContainer, 'click')
    .pipe(
        map((element)=> element.target.closest('a')),
        filter(Boolean)
    )
    .subscribe(trackGAStateLinkEvent);

function trackGAEvent(key) {
    const googleAnalyticsDTO = eventsMapper.get(key);
    store.dispatch(uiStateSlice.actions.trackUserEvent({googleAnalyticsDTO}))
}

fromEvent(navLinks, 'click')
    .pipe(
        map((element)=> element.target.closest('[data-nav-link]')),
        filter(Boolean),
        map((element)=> element.dataset.navLink), 
        filter(Boolean)
    )
    .subscribe(trackGAEvent);

